import styled from'styled-components';
import Form from 'react-bootstrap/Form';

export const ComponentContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3rem;
`;

export const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border: 1px solid #ccc;
  width: fit-content;
  padding: 2rem;
  border-radius: 5px;
  background-color: #fff;
`;
